import { FC } from "react";
import styles from "./ManagementWhatWeOffer.module.scss";
import Image from "next/image";
import { H3, P15 } from "../../../../components/Typography";
import { useTranslation } from "next-i18next";
import { ListPointStarIcon } from "../../../../icons";
import cl from "classnames";
import { RequestCallNew } from "../../../../components/Forms";

const points = ["point1", "point2", "point3", "point4", "point5", "point6"];

interface IManagementWhatWeOffer {}
export const ManagementWhatWeOffer: FC<IManagementWhatWeOffer> = () => {
  const { t } = useTranslation("index", { keyPrefix: "managementPage.whatWeOffer" });
  return (
    <div className={styles.offer}>
      <Image
        sizes="(max-width: 1440px) 1320px, 1474px"
        width={1030}
        height={707}
        className={styles.offer__leaves}
        src={"/image.webp"}
        alt=""
      />
      <div className={cl(styles.container, styles.offer__blocks)}>
        <div className={styles.offer__left}>
          <H3 className={styles.offer__title}>{t("title")}</H3>
          <ul className={styles.offer__list}>
            {points.map((p, i) => {
              return (
                <li key={p}>
                  <div className={styles.offer__listItem}>
                    <div className={styles.offer__star}>
                      <ListPointStarIcon />
                    </div>
                    <P15>{t(p)}</P15>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.offer__form}>
          <H3 className={styles.offer__formTitle}>{t("formTitle")}</H3>
          <RequestCallNew
            eventName={["others"]}
            comment="Передать в управление_нижний экран"
            sourceForm="hand_over_bottom_screen"
            className={styles.offer__formComponent}
            theme="blue"
            agreementText="managementAgreement"
            reverseAgreementOrder
            buttonClass={styles.offer__formButton}
            buttonLabel="giveToManagement"
            leadType="COOP"
          />
          <Image
            sizes="(max-width: 1440px) 1320px, 1474px"
            width={552}
            height={909}
            className={styles.offer__formLeaf}
            src={"/leaves/form_leaf.webp"}
            loader={({ src }) => src}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
